<template>
    <span>
        <a @click.stop="$root.showInfoForSwissCustomers = true" class="info-link">{{ 'More info' | translation }}</a>
    </span>
</template>

<script>

export default {
    name: 'productCustomerInfo',
};
</script>

<style scoped lang="stylus">
@import '~vuetify/src/stylus/settings/_variables.styl';

.info-link {
  font-weight: bold;
  color: white;
}

.info-link:hover {
  color: var(--v-primary-base);
}

</style>
